import { useCallback, useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Mousewheel, A11y, Keyboard } from 'swiper'
import { ApiQuery, findApiV4Link, useJsonApi } from 'shared'
import { Modal } from 'react-overlays'

SwiperCore.use([Navigation, Mousewheel, A11y, Keyboard])

export const Gallery = ({ apiUrl }) => {
  const [isOpen, setIsOpen] = useState(window.location.hash === '#gallery')
  const [page, setPage] = useState(1)
  const [pictures, setPictures] = useState([])
  const swiperRef = useRef()

  const open = (index = 0) => {
    setIsOpen(true)
    if (index) swiperRef.current.slideTo(index)
  }
  const close = () => setIsOpen(false)

  // Expose open and close functions for interactions from SLIM
  useEffect(() => {
    window.openGallery = open
    window.closeGallery = close
  }, [open, close, swiperRef.current])

  const query = new ApiQuery(apiUrl)
  const currentPageUrl = query.per(3).page(page).toUrl()
  const { data, loading } = useJsonApi(currentPageUrl)

  // Whenever new pictures have been loaded, add them to the stack
  useEffect(() => {
    loading || data.data && setPictures(pictures.concat(data.data))
  }, [loading])

  // Swiper ignores updates to onReachEnd, so use a ref.
  const pageRef = useRef(1)
  const onReachEnd = useCallback(() => setPage(pageRef.current += 1), [])

  if (pictures.length === 0) return null

  const content = pictures.map((picture, index) =>
    <SwiperSlide key={`pic-${picture.id}`}>
      <Picture {...picture} index={index} total={data.total_entries || '?'} close={close} />
    </SwiperSlide>
  )

  return <Modal
    aria-labelledby='modal-label'
    show={isOpen}
    onHide={close}
    className='projects-show-gallery-modal'
    renderBackdrop={() => <div className='projects-show-gallery-modal-backdrop'></div>}
  >
    <div className='gallery-content'>
      <Swiper
        slidesPerView={1}
        navigation={{
          nextEl: '#gallery-button-next',
          prevEl: '#gallery-button-prev',
          disabledClass: 'disabled',
        }}
        scrollbar={{ hide: false }}
        keyboard
        centeredSlides
        roundLengths
        mousewheel={{ forceToAxis: true }}
        ref={swiperRef}
        onReachEnd={onReachEnd}
      >
        {content}
      </Swiper>
      <div id='gallery-button-prev'></div>
      <div id='gallery-button-next'></div>
      <div id='gallery-button-close' onClick={close}></div>
    </div>
  </Modal>
}

const Picture = ({ close, index, total, ...picture }) => {
  const srcUrl = findApiV4Link({ ofObject: picture, withRel: 'image' })

  const handleClick = (event) => {
    if (event.target.className == 'fake-backdrop') {
      event.preventDefault()
      close()
    }
  }

  return <div className='swiper-slide text-center'>
    <div className='fake-backdrop' onClick={handleClick}>
      <img src={srcUrl} className='gallery-image' />
      <div className='gallery-description pt-4'>
        <p>{picture.description}</p>
        {index + 1} / {total}
      </div>
    </div>
  </div>
}
